import { render } from "./FormDiscountField.vue?vue&type=template&id=e18ac456"
import script from "./FormDiscountField.vue?vue&type=script&lang=js"
export * from "./FormDiscountField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormDiscountField.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e18ac456"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e18ac456', __exports__)) {
    console.log('reload')
    api.reload('e18ac456', __exports__)
  }
  
  module.hot.accept("./FormDiscountField.vue?vue&type=template&id=e18ac456", () => {
    console.log('re-render')
    api.rerender('e18ac456', render)
  })

}


export default __exports__